
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Previewer from 'vux/src/components/previewer/index.vue'

import Swiper from 'swiper'
import mapUtil from '@/javascript/mapUtil'
import payPublic from '@/javascript/payPublic'
import EsQuery from '@/javascript/esQuery'
import { formatDate } from "@/javascript/formatDate"
import axios from 'axios'
import util from '@/javascript/util'
import Footer from "@/components/lyx-components/lyx-footer/index"


import mapList from '@/components/public-components/mapList/index.vue'
import goBack from '@/components/public-components/goBack/index.vue'

export default {
name: 'hotelDetails',
components: {
Tab,
TabItem,
Previewer,
mapList,
goBack,
Footer
},
data () {
return {
descriptionLength: '',
infiniteAll: true,
isWeixin: util.isWeiXin(),
showMapList: false,
minHeight: 0,
today: '',
nowTime: '',
dateRange: '',
spotList: [],
foodList: [],
hotelList: [],

bookMask: false,
hotelEntity: {},
imageList: [],
noShow: false, //暂时不显示
contactEntity: {},
currentTitle: '',
curLng: '',
curLat: '',
videoList: [],
showList: false,
hasVideo: false,
hasImages: true,
videoShow: false, // 显示播放视频
videoUrl: '', // 播放视频链接
typeList: [],
styleDetails: {},
show: false,
coverOpacity: false,
initDate: {},
checkIn: '',
currentPage: 1,
nearkind: ['美食', '酒店'],
curNear: 0,
nearList: [],
positionData: '',
serveList: [],
serviceData: [],
picLength: [],
showPic: false,
collectParams: {
catalog: this.XQSC_TYPE_CODE.JD, //类别
picUrl: '', //图片URL
principalId: '', //被收藏对象id
serviceType: this.SERVICE_TYPE.JD, //浏览信息所属的服务类型
summary: '', //简介  (this.collectParams.summary == null) ? this.collectParams.subTitle : this.collectParams.summary
title: '', //浏览信息页面的标题
articleSite: '', //浏览页面信息的地址
}
}
},
created () {

},
watch: {
"$route" (to, from) {

if (to.name === from.name && to.fullPath !== from.fullPath) {

this.curNear = 0
this.init()
this.tagsData()
}
}
},
mounted () {
this.minHeight = document.documentElement.clientHeight
this.init()

this.getList()
this.apiSearch()
},
methods: {
seeMore () {
this.infiniteAll = !this.infiniteAll;
},
apiSearch() {
const _this = this
const querystring = require('querystring');
const houseEsQuery = new EsQuery()
houseEsQuery


.addString("id", this.$route.params.id, houseEsQuery.and, false)
.addStartWith("deptCode", _this.DEPT_CODE.DEPTCODE, houseEsQuery.and, false)
.addPage(0, 1)
const houseEsJsonQuery = JSON.stringify(houseEsQuery.getArray())
_this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
indexName: _this.INDEX_NAME_TYPE.hotelList,
esJsonQuery: houseEsJsonQuery
})).then(function (res) {
_this.picLength = res.data.data[0]._source.images
})
},
init () {

this.$http.get("/api/wtcp-bics/public/hotel/findHotelInfoById/" + this.$route.params.id).then(res => {
const data = res.data.data
this.hotelEntity = data.hotelEntity
this.descriptionLength = this.hotelEntity.content.length;

data.fileList.image.all.materials.forEach(item => {
if (item.fileUrl.indexOf('\\') != -1) {
item.fileUrl = item.fileUrl.replaceAll("\\", "/\/")
}
this.$set(item, 'src', this.PIC_BASE_URL + item.fileUrl);
})

this.videoList = data.fileList.video.all.materials

this.contactEntity = data.contactEntity

}).then(() => {
const _this = this
document.title = _this.hotelEntity.title
_this.$nextTick(() => {
new Swiper('.reserve-swiper', {
onSlideChangeStart: function (swiper) {
_this.currentPage = swiper.activeIndex + 1
}
})
})

if (this.imageList.length == 0) {
this.hasVideo = true
}
this.currentTitle = this.hotelEntity.title
this.curLng = this.hotelEntity.longitude
this.curLat = this.hotelEntity.latitude


this.$http.get("/api/wtcp-coder/public/dict/findByCode?code=147").then(res => {
this.serveList = res.data.data
}).then(() => {
this.serviceData = []
const serData = this.hotelEntity.services.split(',')
for (let i = 0; i < serData.length; i++) {
for (let j = 0; j < this.serveList.length; j++) {
if (serData[i] == this.serveList[j].id) {

let data = {
name: this.serveList[j].name,

pic: require('../../../assets/public-img/ser_' + this.serveList[j].id + '.png')
}
this.serviceData.push(data)
}
}
}
})
})
},
goMoreList (name, params) {


this.$router.push({
name: name,
params: params
})
},
book () {
if (this.hotelEntity.bookingLink && this.hotelEntity.bookingLink != "暂无") {
window.open(this.hotelEntity.bookingLink)
} else {
alert("暂时无法预定")
}
},
closePic (arg) {
this.imageList = []
this.showPic = false
},

showViewer (item) {
const _this = this
_this.showPic = true
if (item) {
_this.imageList = item.commodityImages
setTimeout(function () {
_this.$refs.previewer.show(0)
}, 200)
} else {
_this.imageList = _this.picLength
setTimeout(function () {
_this.$refs.previewer.show(_this.currentPage - 1)
}, 200)
}
},
callPhone () {
if (this.contactEntity && this.contactEntity.phone != "暂无" && this.contactEntity.phone) {
payPublic.callPhone(this.contactEntity.phone)
} else {
payPublic.showPrompt(`暂无电话`)
}
},
gpsJump (item) {
/**
* 定位
*/
mapUtil.locate((data) => {
window.location.href = 'https://map.qq.com/nav/drive#routes/page?eword=' + item.title + '&noback=&referer=groupActivity_myapp&ch=mc_h5marker&start=' + data.position.lng + ',' + data.position.lat + '&dest=' + item.longitude + ',' + item.latitude + '&sword=我的位置'
}, (data) => {
window.location.href = 'https://map.qq.com/nav/drive#routes/page?eword=' + item.title + '&noback=&referer=groupActivity_myapp&ch=mc_h5marker&start=' + data.position.lng + ',' + data.position.lat + '&dest=' + item.longitude + ',' + item.latitude + '&sword=我的位置'
})

},














getList () {
const _this = this
const querystring = require('querystring')


const allXcEsQuery = new EsQuery()
allXcEsQuery
allXcEsQuery
.addString("category", _this.XXCJ_TYPE_CODE.MS, allXcEsQuery.and, false)



.addPage(0, 3)
const allXcEsJsonQuery = JSON.stringify(allXcEsQuery.getArray())
_this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
indexName: _this.INDEX_NAME_TYPE.periphery,
esJsonQuery: allXcEsJsonQuery
})).then(res => {
if (res.data.data.length > 0) {
res.data.data.forEach(item => {
item._source.distance = mapUtil.getDistance(_this.hotelEntity.longitude, _this.hotelEntity.latitude, item._source.longitude, item._source.latitude)
})
_this.foodList = res.data.data



}

}).then(() => {

const serviceEsQuery = new EsQuery()
serviceEsQuery
.addString("category", _this.XXCJ_TYPE_CODE.JQ, serviceEsQuery.and, false)
.addStartWith("deptCode", _this.DEPT_CODE.DEPTCODE, serviceEsQuery.and, false)
.addPage(0, 3)
const lineEsJsonQuery = JSON.stringify(serviceEsQuery.getArray())
_this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
'indexName': _this.INDEX_NAME_TYPE.scenic,
'esJsonQuery': lineEsJsonQuery
})).then(res => {
res.data.data.forEach(item => {
item._source.distance = mapUtil.getDistance(_this.hotelEntity.longitude, _this.hotelEntity.latitude, item._source.longitude, item._source.latitude)
})
_this.spotList = res.data.data

}).then(() => {

const houseEsQuery = new EsQuery()
houseEsQuery


.addString("deptCode", _this.DEPT_CODE.DEPTCODE, houseEsQuery.and, false)
.addPage(0, 3)
const houseEsJsonQuery = JSON.stringify(houseEsQuery.getArray())
_this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
indexName: _this.INDEX_NAME_TYPE.hotelList,
esJsonQuery: houseEsJsonQuery
})).then(res => {
const data = res.data.data
if (data.length > 1) {
data.splice(0, 1)
res.data.data.forEach(item => {
item._source.distance = mapUtil.getDistance(_this.hotelEntity.longitude, _this.hotelEntity.latitude, item._source.longitude, item._source.latitude)
})
_this.hotelList = data
}
}).then(() => {
if (_this.foodList.length > 0) {
_this.nearList = _this.foodList
} else if (_this.foodList.length == 0 && _this.spotList.length > 0) {
if (_this.taListbData.length > 0) {
_this.spotList.forEach(item => {
const arr = []
if (item._source.tags) {
item._source.tags.forEach(tag => {
_this.taListbData.forEach(current => {
if (tag == current.name) {
arr.push(tag)
}
})
})
}
item._source.tags = arr
})
}
_this.curNear = 1
_this.nearList = _this.spotList
} else if (_this.spotList.length == 0 && _this.foodList.length == 0 && _this.hotelList.length > 0) {
_this.nearList = _this.hotelList
_this.curNear = 2
}
})
}).finally(() => {
_this.isLoaded = true
})
this.showList = true
})
},
changeNear (item, index) {
this.curNear = index
switch (index) {
case 0:

this.resultList(this.INDEX_NAME_TYPE.periphery, this.XXCJ_TYPE_CODE.MS)
break
case 1:

this.resultList(this.INDEX_NAME_TYPE.scenic, this.XXCJ_TYPE_CODE.JQ)
break
case 2:

this.resultList(this.INDEX_NAME_TYPE.hotelList, this.XXCJ_TYPE_CODE.JD)
break

default:
break
}
},

nearDetails (item) {
switch (this.curNear) {
case 0:
this.$router.push('/specialDetails/T/' + item._source.id)
break;
case 1:
this.$router.push('/scenicView/' + item._source.id)
break;
case 2:
this.changeNear('美食',0)
this.$router.replace('/hotelDetails/' + item._source.id)

break;

default:
break;
}
},
resultList (indexName, listName) {
const _this = this
const querystring = require('querystring')
const rusultEsQuery = new EsQuery()
if (indexName == 'wtcp-bic-poi') {
rusultEsQuery.addStartWith("deptCode", listName, rusultEsQuery.and, false)
.addStartWith("type", '127001', rusultEsQuery.and, false)
.addPage(0, 3)
} else {
rusultEsQuery.addStartWith("category", listName, rusultEsQuery.and, false)
.addString("deptCode", _this.DEPT_CODE.DEPTCODE, rusultEsQuery.and, false)
.addPage(0, 3)
}

const rusultEsJsonQuery = JSON.stringify(rusultEsQuery.getArray())
_this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
indexName: indexName,
esJsonQuery: rusultEsJsonQuery
})).then(res => {
let data = res.data.data
data.forEach(item => {
item._source.distance = mapUtil.getDistance(_this.hotelEntity.longitude, _this.hotelEntity.latitude, item._source.longitude, item._source.latitude)
})
_this.$set(_this, 'nearList', data)
})
},
}
}
